module.exports = __webpack_public_path__ + "static/media/avatar-person.22fd7095.svg";